<template>
  <div class="menuItem">
    <img
      class="logo"
      :src="require(`@/lib/tui/assets/logo/${svgPath}`)"
      alt="item.label"
    />
  </div>
</template>

<script>
export default {
  name: "CLogo",
  //////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////
  props: {
    svgPath: String,
    svgWidth: String,
    svgMargin: String
  }
};
</script>

<style lang="scss" scoped>
  .logo {
    width: v-bind(svgWidth);
    height: 4vh;
    margin: v-bind(svgMargin);
    margin-top: 0.8vh;
  }
</style>
